import './Page.scss';
import './Page-Content.scss';
import './Skiplink.scss';
import './Teaser.scss';
import './TeaserCard/TeaserCard.scss';
import { forAll } from '@stst/Javascript/util';
import { linkCard } from '@stst/components/General/Card';

forAll('.page-teaser', teaser => {
    linkCard(
        (/** @type {HTMLElement} */(teaser)),
        teaser => teaser.querySelector('.page-teaser__link'),
        teaser => teaser.classList.add('linked-title__container')
    );
});
